import React, { FunctionComponent } from 'react';

const OrderConfirmationSection: FunctionComponent = ({ children }) => (
    <section className="orderConfirmation-section">{children}</section>
);

export default OrderConfirmationSection;
